'use strict';

/**
 * @classname SetFavoriteShop
 * @classdesc 会員登録お気に入り店舗設定
 */
export default class SetFavoriteShop {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-register-confirm
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		let shopSelected = window.localStorage.getItem('_cfs_') || null;
		shopSelected = JSON.parse(shopSelected);
		const shopId = shopSelected.shopId;
		if(shopSelected && shopId){
			document.cookie = `my_shop=${shopId};path=/`;
		}
	};
};
